/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { gnoment } from 'shared-ui/gnoment';
import { Row, GridHeaderCell } from './Grid';
import SortableTableColumnHeader from './SortableTableColumnHeader';

export default class AvailabilityTableHeader extends React.PureComponent {
    static propTypes = {
        divisionType: PropTypes.string,
        hasAreaData: PropTypes.bool,
        sort: PropTypes.shape({
            column: PropTypes.string,
        }),
        startDate: PropTypes.any,
        onNameSortToggle: PropTypes.func,
        onAreaSortToggle: PropTypes.func,
        numOfCols: PropTypes.number.isRequired,
    };

    render() {
        const {
            divisionType,
            hasAreaData,
            sort,
            startDate,
            onNameSortToggle,
            onAreaSortToggle,
            numOfCols,
        } = this.props;

        return (
            <div>
                <Row>
                    <SortableTableColumnHeader
                        name={divisionType}
                        isSorted={sort.column === 'name' ? sort.isSorted : false}
                        isAsc={sort.column === 'name' ? sort.isAsc : false}
                        onSortToggle={onNameSortToggle}
                    />
                    {hasAreaData && (
                        <SortableTableColumnHeader
                            name="Area"
                            isSorted={sort.column === 'district' ? sort.isSorted : false}
                            isAsc={sort.column === 'district' ? sort.isAsc : false}
                            onSortToggle={onAreaSortToggle}
                        />
                    )}
                    {range(numOfCols).map((i) => {
                        const dt = gnoment(startDate).add(i, 'day');
                        return (
                            <GridHeaderCell key={i} aria-disabled="true">
                                <div>
                                    <span className="rec-sr-only">
                                        {dt.format('dddd, MMMM D, YYYY')}
                                    </span>
                                    <span className="weekday" aria-hidden>
                                        {dt.format('ddd')}
                                    </span>
                                    <span className="date" aria-hidden>
                                        {dt.format('D')}
                                    </span>
                                </div>
                            </GridHeaderCell>
                        );
                    })}
                </Row>
            </div>
        );
    }
}
